var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{attrs:{"elevation":hover ? 6 : 2}},[_c('v-card-text',[_c('v-data-table')],1)],1)]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }